import React from 'react';
import { Button } from '@mui/material';
import { useGuardedNavigation } from '../../../permissions/useGuardedNavigation';

export default function MeterListPageActions() {
  const { navigateCreate } = useGuardedNavigation('meters');

  return (
    <Button variant="contained" color="primary" onClick={navigateCreate}>
      + Create New Meter
    </Button>
  );
}
